import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FeedLine } from 'src/app/services/helper.service';
import { OilSpillLegendGroup } from './oil-spill-legend.model';

@Component({
  selector: 'app-oil-spill-legend',
  templateUrl: './oil-spill-legend.component.html',
  styleUrls: ['./oil-spill-legend.component.scss'],
})
export class OilSpillLegendComponent implements OnChanges {
  @Input() groups: OilSpillLegendGroup[] = [];
  @Input() extraItems: FeedLine[] = [];

  collapsed = false;
  private expandedGroupIds = new Set<string>();

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['groups']) return;

    const validIds = new Set(this.groups.map((group) => group.id));
    const previousIds = new Set(
      ((changes['groups'].previousValue ?? []) as OilSpillLegendGroup[]).map((group) => group.id)
    );
    // Clearing a filter restores detection groups; expand all when groups are added back.
    if (this.groups.some((group) => !previousIds.has(group.id))) {
      this.expandedGroupIds = validIds;
      return;
    }
    const retainedIds = [...this.expandedGroupIds].filter((id) => validIds.has(id));
    this.expandedGroupIds = new Set(retainedIds);
  }

  toggleLegend(): void {
    this.collapsed = !this.collapsed;
  }

  toggleGroup(group: OilSpillLegendGroup): void {
    if (this.expandedGroupIds.has(group.id)) {
      this.expandedGroupIds.delete(group.id);
    } else {
      this.expandedGroupIds.add(group.id);
    }
  }

  isExpanded(group: OilSpillLegendGroup): boolean {
    return this.expandedGroupIds.has(group.id);
  }

  trackGroup(_: number, group: OilSpillLegendGroup): string {
    return group.id;
  }

  trackForecast(_: number, forecast: { hour: number }): number {
    return forecast.hour;
  }

  trackExtraItem(index: number, item: FeedLine): string {
    return `${item.text}-${index}`;
  }
}
